export default __webpack_public_path__ + "static/case1-7da08f4ee1bcba54c43ab93fc923e66d.png";